(function () {
  'use strict';

  angular.module('ringbaPortal').component('offerParticipationTasks', {
    bindings: {
      campaignId: '<',
      isOfferTasks: '<',
      scrollToOfferRequests: '<',
      showCampaignTab: '&',
      showPublisherSettings: '&',
      reloadCampaign: '&'
    },
    controller: OfferParticipationTasksController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/offer/offer-participation-tasks/offer-participation-tasks.view.html'
  });

  function OfferParticipationTasksController(
    $timeout,
    utils
  ) {
    'ngInject';

    const vm = this;
    const publisherPanelId = 'panel-publisher-number';
    const offerRequestsPanel = 'panel-offer-requests';

    vm.reloadData = {};
    vm.textsTranslations = {
      open: {
        title: 'OPEN_OFFERS_REQUESTS',
        loading: 'LOADING_OPEN_OFFER_REQUESTS',
        empty: 'NONE_OPEN_OFFER_REQUESTS'
      },
      completed: {
        title: 'COMPLETED_OFFERS_REQUESTS',
        loading: 'LOADING_COMPLETED_OFFER_REQUESTS',
        empty: 'NONE_COMPLETED_OFFER_REQUESTS'
      }
    };
    vm.tasksCount = {};

    vm.$onChanges = onChanges;
    vm.setTaskCount = setTaskCount;
    vm.reloadDataForStatus = reloadDataForStatus;
    vm.showTab = showTab;

    function onChanges(changesObj) {
      if (changesObj.scrollToOfferRequests && vm.scrollToOfferRequests) {
        _scrollToOfferRequestsPanel();
      }
    }

    function setTaskCount(count, taskStatus) {
      vm.tasksCount[taskStatus] = count;
    }

    function reloadDataForStatus(status) {
      vm.reloadCampaign();
      vm.reloadData[status] = true;

      $timeout(function() {
        vm.reloadData[status] = false;
      }, 10);
    }

    // TODO: Move the scroll to publisher panel function to a common place, in the parent component
    function showTab() {
      vm.showCampaignTab();

      $timeout(function () {
        utils.scrollToElementId(publisherPanelId, 52);
      }, 200);
    }

    function _scrollToOfferRequestsPanel() {
      // TODO: Remove timeout from here
      $timeout(function() {
        utils.scrollToElementId(offerRequestsPanel, 50);
      }, 100);
    }

  }
})();
